
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "C'est quoi un plugin ? Tout savoir sur les plugins",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez tout sur les plugins : ces outils essentiels qui étendent les fonctionnalités de vos applications préférées pour une expérience sur-mesure.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "C'est quoi un plugin ? Tout savoir sur les plugins",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez tout sur les plugins : ces outils essentiels qui étendent les fonctionnalités de vos applications préférées pour une expérience sur-mesure.",
        },
      ],
    };
  },
};
